// The (serveId, position) pair a client echoes back to attribute an
// impression, click or conversion to a logged recommendation serve. Lives in
// shared so the server's boundaries (beacons, request-to-join) and the web's
// (a rec context read back from browser storage) validate one shape.
import { z } from 'zod';
// Positions are `smallint` in every decision-log table (absolute across
// pages), so this is the largest position a serve may log or a client may echo.
export const MAX_REC_POSITION = 32767;
export const RecContextSchema = z
    .object({
    serveId: z.string().uuid(),
    position: z.number().int().min(0).max(MAX_REC_POSITION),
})
    .strict();
//# sourceMappingURL=rec-context.js.map